import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/components/TsumugiMessage.css';

/**
 * TsumugiMessage - つむぎからの寄り添いメッセージ
 * MYPAGE_REDESIGN_V2.md 【最優先】2. つむぎからの寄り添いメッセージ
 *
 * バリエーション豊富な定型文をランダム表示
 */

// メッセージデータベース（2-3文構成 + ユーザー名対応）
const MESSAGES = {
  good: {
    normal: [
      {
        main: '{name}さん、今日も元気でいいね！その調子✨',
        sub: '気分が安定している時こそ、自分を大切にする時間を作ってあげてね。',
        footer: 'つむぎはいつでもそばにいるよ'
      },
      {
        main: '{name}さん、調子良さそう！素敵だね',
        sub: 'この調子で、無理のない範囲で今日を楽しんでね。',
        footer: '応援してるよ'
      },
      {
        main: '{name}さん、エネルギッシュでいいね！',
        sub: '元気な時こそ、自分の心の声を聞いてあげることも大切だよ。',
        footer: 'あなたらしく過ごしてね'
      },
      {
        main: '{name}さん、今日も頑張ってるね',
        sub: '無理しすぎないように、自分のペースを守ってね。',
        footer: 'いつでも応援してるよ'
      },
      {
        main: '{name}さん、いい感じだね！',
        sub: 'この気持ち、大切にしながら過ごしてね。',
        footer: 'つむぎはいつもそばにいるよ'
      },
    ],
    depression: [
      {
        main: '{name}さん、今日は調子が良いんだね',
        sub: 'この気持ちを大切にして、マイペースでいこう。',
        footer: '無理せず、そのままの{name}さんでいいんだよ'
      },
      {
        main: '{name}さん、少し元気になれたかな？',
        sub: '小さな変化も、大切な一歩だよ。',
        footer: '焦らずゆっくり、一緒に歩いていこうね'
      },
      {
        main: '{name}さん、今日の気分を大切にしてね',
        sub: '良い日も、そうでない日も、全部あなただから。',
        footer: 'つむぎはいつでもそばにいるよ'
      },
      {
        main: '{name}さん、マイペースで大丈夫だよ',
        sub: '自分のペースを守ることが、一番大切なことだから。',
        footer: '焦らなくていいんだよ'
      },
      {
        main: '{name}さん、今日のあなたを応援してるよ',
        sub: 'どんな気分の日も、あなたはあなた。',
        footer: 'そのままで素敵だよ'
      },
    ],
  },
  normal: {
    normal: [
      {
        main: '{name}さん、今日も自分のペースで大丈夫だよ',
        sub: 'いつも通りの日も、大切な一日だから。',
        footer: 'あなたらしく過ごしてね'
      },
      {
        main: '{name}さん、無理せずマイペースでね',
        sub: '普通の日々の積み重ねが、あなたを支えてくれるから。',
        footer: 'つむぎはいつでもここにいるよ'
      },
      {
        main: '{name}さん、今日も一歩ずつゆっくりと',
        sub: '焦らなくていい。あなたのペースで十分だよ。',
        footer: '応援してるからね'
      },
      {
        main: '{name}さん、今日もお疲れさま',
        sub: '何気ない日常も、あなたが過ごしているだけで素敵だよ。',
        footer: 'いつでもそばにいるからね'
      },
      {
        main: '{name}さん、そのままで十分だよ',
        sub: '特別なことをしなくても、あなたは大切な存在だから。',
        footer: 'つむぎはいつも応援してるよ'
      },
    ],
    depression: [
      {
        main: '{name}さん、今日はこんな感じなんだね',
        sub: 'どんな気分の日も、受け止めているよ。',
        footer: '無理しなくていいからね'
      },
      {
        main: '{name}さん、そのままでいいんだよ',
        sub: '今の気持ちを、そのまま大切にしてね。',
        footer: 'あなたのペースで大丈夫'
      },
      {
        main: '{name}さん、焦らなくて大丈夫',
        sub: '今はゆっくり、自分を労わる時間にしよう。',
        footer: 'つむぎはずっとそばにいるよ'
      },
      {
        main: '{name}さん、今の気持ち、受け止めてるよ',
        sub: '辛い時は、何もしなくていいんだよ。',
        footer: '一人じゃないからね'
      },
      {
        main: '{name}さん、ゆっくりでいいからね',
        sub: '自分のペースを守ることが、何より大切だから。',
        footer: 'あなたのタイミングで大丈夫だよ'
      },
    ],
  },
  tired: {
    normal: [
      {
        main: '{name}さん、お疲れさま。無理しないでね',
        sub: '疲れた時は、自分を甘やかしてあげる時間だよ。',
        footer: 'ゆっくり休んでね'
      },
      {
        main: '{name}さん、今日は疲れたね',
        sub: '頑張りすぎてない？少し自分を労わってあげて。',
        footer: '休むことも大切なことだからね'
      },
      {
        main: '{name}さん、疲れを感じたら体のサインだよ',
        sub: '無理せず、早めに休息を取ってね。',
        footer: 'つむぎはいつでもそばにいるよ'
      },
      {
        main: '{name}さん、今日はもう十分頑張ったよ',
        sub: 'これ以上無理しなくていいからね。',
        footer: '自分を大切にしてあげて'
      },
      {
        main: '{name}さん、たまには自分を甘やかしてあげて',
        sub: '頑張りすぎているあなたこそ、休む権利があるんだよ。',
        footer: 'ゆっくり過ごしてね'
      },
    ],
    depression: [
      {
        main: '{name}さん、辛かったね',
        sub: '今は何もしなくていい。ただ休むことを優先してね。',
        footer: 'つむぎはずっとそばにいるよ'
      },
      {
        main: '{name}さん、そばにいるよ。一人じゃないよ',
        sub: '辛い時は、無理に笑わなくていいんだよ。',
        footer: 'そのままの{name}さんでいいから'
      },
      {
        main: '{name}さん、今日はもう頑張らなくていいよ',
        sub: 'ゆっくり、ゆっくりでいいからね。',
        footer: '休むことも大切なことだよ'
      },
      {
        main: '{name}さん、あなたのペースで大丈夫',
        sub: '焦らなくていい。今は自分を労わる時間にしよう。',
        footer: 'いつでもここにいるからね'
      },
      {
        main: '{name}さん、そのままのあなたでいいんだよ',
        sub: '無理して何かをする必要はないからね。',
        footer: 'つむぎはあなたの味方だよ'
      },
    ],
  },
  // 気分未記録時
  none: {
    normal: [
      {
        main: '{name}さん、今日はどんな感じ？',
        sub: '気が向いたら、気分を教えてね。',
        footer: 'あなたのペースで大丈夫だよ'
      },
      {
        main: '{name}さん、つむぎはいつでもここにいるよ',
        sub: '無理せず、自分のタイミングで記録してみてね。',
        footer: '応援してるからね'
      },
      {
        main: '{name}さん、今日も一日お疲れさま',
        sub: '気分の記録は、あなたのペースで大丈夫。',
        footer: 'いつでもそばにいるよ'
      },
    ],
    depression: [
      {
        main: '{name}さん、そばにいるよ',
        sub: '何もしなくても大丈夫。',
        footer: 'いつでもここにいるからね'
      },
      {
        main: '{name}さん、無理しなくていいよ',
        sub: '今は休むことを優先してね。',
        footer: 'あなたのペースで'
      },
      {
        main: '{name}さん、ゆっくりでいいんだよ',
        sub: '焦らなくていい。今のままで大丈夫だから。',
        footer: 'つむぎはずっとそばにいるよ'
      },
    ],
  },
};

const TsumugiMessage = ({ mood, depressionMode, userName }) => {
  const navigate = useNavigate();

  // ランダムにメッセージを選択（useMemoでマウント時に固定）
  const message = useMemo(() => {
    const moodKey = mood || 'none';
    const modeKey = depressionMode ? 'depression' : 'normal';
    const messageList = MESSAGES[moodKey]?.[modeKey] || MESSAGES.none.normal;
    const selectedMessage = messageList[Math.floor(Math.random() * messageList.length)];

    // ユーザー名を挿入
    const name = userName || 'あなた';
    return {
      main: selectedMessage.main.replace('{name}', name),
      sub: selectedMessage.sub.replace('{name}', name),
      footer: selectedMessage.footer.replace('{name}', name),
    };
  }, [mood, depressionMode, userName]);

  // アイコンとBEM modifier
  const getMoodModifier = () => {
    // つむぎの表情を気分に応じて選択
    if (depressionMode || mood === 'tired') {
      return {
        icon: '/Sad.png', // 優しく寄り添う表情（悲しみ・疲れ）
        modifier: depressionMode ? 'depression' : 'tired',
      };
    }
    if (mood === 'good') {
      return {
        icon: '/Happy.png', // 喜んでいる表情
        modifier: 'good',
      };
    }
    return {
      icon: '/Neutral.png', // 穏やかな表情（通常）
      modifier: 'normal',
    };
  };

  const { icon, modifier} = getMoodModifier();

  return (
    <div className="tsumugi-card">
      <div className="tsumugi-message-header">
        <img
          src={icon}
          alt="つむぎ"
          className="tsumugi-message-icon"
        />
        <h3 className="tsumugi-card-title">つむぎからのメッセージ</h3>
      </div>

      <div className={`tsumugi-message-body tsumugi-message-body--${modifier}`}>
        <p className="tsumugi-message-text">
          {message.main}
          <br />
          {message.sub}
          <br />
          <span className="tsumugi-message-footer">
            {message.footer}
          </span>
        </p>

        <div className="tsumugi-message-buttons">
          <button
            className="tsumugi-btn tsumugi-btn-primary tsumugi-message-button"
            onClick={() => navigate('/chat?new=true')}
          >
            ✨ 新しく話す
          </button>
          <button
            className="tsumugi-btn tsumugi-btn-outline tsumugi-message-button"
            onClick={() => navigate('/chat?continue=true')}
          >
            💬 続きから
          </button>
        </div>
      </div>
    </div>
  );
};

export default TsumugiMessage;
